export const getSupplierCardSize = ({
  isSupplierProfile,
  highRes,
  fullBleed,
}: {
  isSupplierProfile?: boolean;
  highRes?: boolean;
  fullBleed?: boolean;
}) => {
  const extraHeight = fullBleed ? 30 : 0;
  if (isSupplierProfile) {
    const width = highRes ? 750 : 460;
    const height = highRes ? 710 : 435 + extraHeight;
    return [width, height];
  } else {
    const width = highRes ? 800 : 460;
    const height = highRes ? 536 : 310 + extraHeight;
    return [width, height];
  }
};
